import React from 'react';
import GuestRegisterPromptModal from './GuestRegisterPromptModal';
import PermissionsModal from '../PermissionsModal';
import PayInvoicesModal from './PayInvoicesModal';
import {
	Modals,
	useDocumentFollowupActions,
} from './useDocumentFollowupActions';
import SignContractsModal from './SignContractsModal';
import AcceptProposalsModal from './AcceptProposalsModal';

export type DocumentFollowupActionsProps = Pick<
ReturnType<typeof useDocumentFollowupActions>,
'modal'
>;

export const DocumentFollowupActions: React.FC<
DocumentFollowupActionsProps
> = ( { modal } ) => (
	<>
		{ modal?.type === Modals.PlannerPermissions ? (
			<PermissionsModal { ...modal.data } />
		) : null }
		<GuestRegisterPromptModal
			open={ modal?.type === Modals.GuestSignUp }
			{ ...( modal?.type === Modals.GuestSignUp ? modal?.data : {} ) }
		/>
		<PayInvoicesModal
			open={ modal?.type === Modals.PayInvoices }
			{ ...( modal?.type === Modals.PayInvoices
				? modal?.data
				: { excludedDocumentId: '' } ) }
		/>
		<SignContractsModal
			open={ modal?.type === Modals.SignContracts }
			{ ...( modal?.type === Modals.SignContracts
				? modal?.data
				: { excludedDocumentId: '' } ) }
		/>
		<AcceptProposalsModal
			open={ modal?.type === Modals.AcceptProposals }
			{ ...( modal?.type === Modals.AcceptProposals
				? modal?.data
				: { excludedDocumentId: '' } ) }
		/>
	</>
);
